import { Http } from "@/util";
import { downloadFile, uploadFiles } from "@/util/http";

// 获取培训资料列表
export function getTrainingMaterialsList(params) {
  return Http.post("/admin/newtraining/materials/list", params);
}

// 保存或更新培训资料
export function saveTrainingMaterials(data) {
  return Http.post("/admin/newtraining/materials/save", data);
}

// 删除培训资料
export function deleteTrainingMaterials(trainMaterialsId) {
  return Http.get(`/admin/newtraining/materials/delete`, { trainMaterialsId });
}

// 获取考试详情
export function getTrainMaterials(materialId) {
  return Http.get("/admin/newtraining/materials/detail", { materialId });
}

// 获取考试列表
export function getTrainingExamList(params) {
  return Http.post("/admin/newtraining/exam/list", params);
}

// 保存或更新考试
export function saveTrainingExam(data) {
  return Http.post("/admin/newtraining/exam/save", data);
}

// 删除考试
export function deleteTrainingExam(trainExamId) {
  return Http.get("/admin/newtraining/exam/delete", { trainExamId });
}

// 获取考试详情
export function getTrainExam(trainExamId) {
  return Http.get("/admin/newtraining/exam/detail", { trainExamId });
}

// 下载题库导入模板
export function downloadTrainingExamTemplate() {
  downloadFile("/admin/newtraining/exam/import/template", {}, "考试题库导入模板.xlsx");
}

// 解析题库 Excel，不保存
export function importTrainingExam(formData) {
  return uploadFiles("/admin/newtraining/exam/import", formData);
}

// 获取培训任务列表
export function getTrainingList(params) {
  return Http.post("/admin/newtraining/training/list", params);
}

// 保存或更新培训任务
export function saveTraining(data) {
  return Http.post("/admin/newtraining/training/save", data);
}

// 复制培训任务，不复制司机分配
export function copyTraining(trainingId) {
  return Http.post("/admin/newtraining/training/copy", { trainingId });
}

// 删除培训任务
export function deleteTraining(trainingId) {
  return Http.get(`/admin/newtraining/training/delete`, { trainingId });
}

// 为司机批量创建培训任务
export function createDriverTraining(params) {
  return Http.post("/admin/newtraining/driver/create", params);
}

// 获取司机培训列表
export function getDriverTrainingList(trainingId) {
  return Http.get("/admin/newtraining/driver/list", { trainingId });
}

export function approveDriverFaceReview(driverTrainingId) {
  return Http.post("/admin/newtraining/driver/face_review/approve", { driverTrainingId });
}

export function rejectDriverFaceReview(driverTrainingId) {
  return Http.post("/admin/newtraining/driver/face_review/reject", { driverTrainingId });
}

export function listTrainingTriggerRules() {
  return Http.post("/admin/newtraining/trigger/list", { _hideLoading: true });
}

export function saveTrainingTriggerRule(data) {
  return Http.post("/admin/newtraining/trigger/save", data);
}

export function deleteTrainingTriggerRule(id) {
  return Http.post("/admin/newtraining/trigger/delete", { id });
}

export function listTrainingTriggerLogs(params) {
  return Http.post("/admin/newtraining/trigger/log/list", params);
}

export function retryTrainingTriggerLog(id) {
  return Http.post("/admin/newtraining/trigger/log/retry", { id });
}
